<template>
    <div>
      <slot>
        <div class="row row-spacing mb-2">
          <div class="col-md-auto">
            <button v-if="userEditRight" type="button" class="btn btn-info" @click="createNewPackage()">
             Add New Packages
            </button>
          </div>
        </div>
      </slot>
      <div
        class="table-responsive table-bordered"
        v-if="packages.length > 0"
      >
        <table class="table">
            <thead>
            <tr class="text-nowrap">
                <th>Description</th>
                <th>NRC (excl. VAT)</th>
                <th>MRC (excl. VAT)</th>
                <th>Expired</th>
                <th></th>
            </tr>
            </thead>
            <tbody>
            <tr
                v-for="splaPackage in packages"
                :key="splaPackage.hostAfricaSplaPackageNumber"
            >
                <td> 
                  <input disabled type="text" class="form-control" v-model="splaPackage.description"/>
                </td>
                <td>
                    <span>{{  getSetupFee(splaPackage.hostafricasplapackageprices, period)  }}</span>
                  </td>
                <td>
                {{
                    getPrice(splaPackage.hostafricasplapackageprices, period)
                }}
                <span
                    v-if="userEditRight"
                    style="cursor: pointer"
                    @click="openPriceModal(splaPackage)"
                    v-tooltip="'Edit Row Price'"
                    class="pull-right"
                >
                    <em class="fa fa-edit fa-fw text-green"></em>
                </span> 
                </td>
                <td class="text-center">
                  <span class="badge" :class="splaPackage.expired ? 'badge-warning' : 'badge-green'">
                    {{ splaPackage.expired }}
                  </span>
                </td>
                <td class="text-center">
                  <button v-if="userEditRight" v-tooltip="'Edit Package'" @click="editPackage(splaPackage)" type="button" class="btn btn-sm btn-info m-1">
                    <em class="fa fa-edit fa-fw"></em>
                  </button>
                  <button v-if="userEditRight" v-tooltip="'Delete Row'" type="button" @click="deletePackage(splaPackage)"
                    class="btn btn-sm btn-primary">
                    <em class="fa fa-trash fa-fw"></em>
                  </button>
                </td>
            </tr>
            </tbody>
        </table>
      </div>
      <div v-else class="alert alert-info">No Prices Available to Display</div>
      
      <GenericModifyPackage
            ref="packageModal"
            :pricePackage="newPricePackage"
            @packageAdded="packageAdded"
            @packageEdited="getPackages()"
      />       
      <AddPriceModal
        ref="addPriceModal"
        :row-price="rowPrice"
        :new-price="newPrice"
        @addPrice="addPrice"
        @pricesAdded="$emit('get-spla-packages')"
        />
    </div>
  </template>
  
  <script>
  import PriceFunctions from "@/components/Admin/PriceFunctions";
  import GenericModifyPackage from "@/components/Admin/Modals/GenericModifyPackage";
  import AddPriceModal from "@/components/Admin/Modals/AddPriceModal";
  export default {
    extends: PriceFunctions,
    props: {
        userEditRight: {
          type: Boolean,
          required: true
        },
        packages: {
          type: Array,
          required: true,
        },
        emptySplaPackage: {
          type: Object,
          required: true,
        },
        productNumber: {
          type: Number,
          required: true,
        }
    },
    components: {
      GenericModifyPackage,
      AddPriceModal
    },
    data() {
      return {
        newPricePackage: {},
        rowPrice: [],
        newPrice: {},
        period: this.getCurrentPeriod(),
      };
    },
    mounted() {
      
    },
    methods: {
      getPackages() {
        this.$emit("get-spla-packages");
      },
      packageAdded(splaPackage) {
        splaPackage.hostafricasplapackageprices = [];
        this.packages.push(splaPackage);
        this.openPriceModal(splaPackage);
      },
      createNewPackage() {
        this.$http.get(this.$config.aimsAPI + "pricing/new/package/HostAfricaSplaPackage")
        .then(
          (response) => {
            this.newPricePackage = response.data;
            this.newPricePackage.productNumber = this.productNumber;
            this.$refs.packageModal.open();
          },
          (error) => {
            console.error(error);
            this.showError("Error Fetching SPLA Price template", error);
          }
        );
      },
      setNewPrice(packageNumber) {
        this.$http.get(this.$config.aimsAPI + "pricing/new/price/HostAfricaSplaPackagePrice")
          .then((response) => {
              this.newPrice = response.data;
              this.newPrice.hostAfricaSplaPackageNumber = packageNumber;
            },
            (error) => {
              console.error(error);
              this.showError("Error Fetching Price Template", error);
            }
          );
      },
      editPackage(sPackage) {
        this.newPricePackage = this.deepCopyObject(sPackage);
        this.$refs.packageModal.open();
      },
      openPriceModal(splaPackage) {
        this.setNewPrice(splaPackage.hostAfricaSplaPackageNumber);
        this.rowPrice = this.deepCopyObject(splaPackage.hostafricasplapackageprices || []);
        this.$refs.addPriceModal.open();
      },
      addPrice(newPrice) {
        this.rowPrice.forEach((price) => {
            if (price.validUntil == 0) {
              if (newPrice.validFrom % 100 > 1) {
                  price.validUntil = newPrice.validFrom - 1;
              } else {
                  price.validUntil = newPrice.validFrom - 100 + 11;
              }
            }
        });
        this.rowPrice.push(newPrice);
        this.setNewPrice(newPrice.hostAfricaSplaPackageNumber);
      },
      deletePackage(splaPackage) {
        this.$swal({
            title: "Are you sure you want to delete this price package?",
            type: "warning",
            showCancelButton: true,
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes",
        }).then((result) => {
            if (result.value) {
            this.$http
                .delete(
                this.$config.aimsAPI +
                    "pricing/pricepackages/" +
                    splaPackage.objKey +
                    "?objClassName=" +
                    splaPackage.class
                )
                .then(
                (response) => {
                    this.showSuccess(response.data.message);
                    this.$emit("get-spla-packages");
                },
                (error) => {
                    this.showError("Error Deleting Price Package", error);
                }
                );
            }
        });
      }
    },
  };
  </script>
  